import React from 'react';
import { object, bool } from 'prop-types';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { BQLink } from '../../../../atoms/bqlink';
import { contentClick } from '../../../../../helpers/datalayer-utils';

import './market-image-headline-reaction.m.css';

const MarketImageHeadlineReaction = ({ story }) => {
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));

  return (
    <div styleName="wrapper" className="card-image-reaction-headline" onClick={() => contentClick(userData, story, pageType)}>
      <BQLink href={new URL(story?.link).pathname}>
        <img src={story?.thumb_image + '?downsize=400:225'} alt="thumb image" styleName="thumb-image" />
        <div styleName="headline" className="headline">
          {story?.title}
        </div>
      </BQLink>
    </div>
  );
}

MarketImageHeadlineReaction.propTypes = {
  story: object.isRequired,
};

export default MarketImageHeadlineReaction;
